var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpercutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 30.7332V15.2051C15.8008 6.92339 22.2205 0.0219727 30.2865 0.0219727V15.5502C30.2865 23.8318 23.8667 30.7332 15.8008 30.7332Z",
    fill: "#4239B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4857 30.7335V22.2792C14.4857 13.8251 7.90123 7.09619 0 7.09619V15.5504C0 23.8321 6.41978 30.7335 14.4857 30.7335Z",
    fill: "#4239B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpercutLogo);
export default __webpack_public_path__ + "static/media/upercut-logo.7e563b485bf4379fb2a2fa9b0af24e7a.svg";
export { ForwardRef as ReactComponent };